import { AbstractEvent as t } from "./ghl-ui.es362.js";
class e extends t {
  get draggable() {
    return this.data.draggable;
  }
}
e.type = "draggable";
class g extends e {
}
g.type = "draggable:initialize";
class r extends e {
}
r.type = "draggable:destroy";
export {
  r as DraggableDestroyEvent,
  e as DraggableEvent,
  g as DraggableInitializedEvent
};
